export const FIND_POOL_REQUEST_FAILURE = 'FIND_POOL_REQUEST_FAILURE';

export const findPoolRequestFailure = error => ({
    type: FIND_POOL_REQUEST_FAILURE,
    payload: error,
    error: true,
});
